<template>
  <div id="app" v-if="isLoaded">
    <header :class="{ hidden: this.$route.name == 'home' }">
      <div class="title">
        <router-link :to="{ name: 'home' }">
          <h1>
            <span>E</span><span>S</span><span>T</span> <span>E</span
            ><span>L</span><span>L</span><span>E</span>
          </h1>
          <h1>
            <span>B</span> <span>O</span><span>U</span><span>R</span>
            <span>D</span><span>E</span><span>T</span>
          </h1>
        </router-link>
      </div>
      <navigation></navigation>
    </header>
    <transition name="fade" mode="out-in">
      <router-view></router-view>
    </transition>
    <cart />
  </div>
</template>

<script>
import Navigation from "./components/Navigation.vue";
import Cart from "./components/Cart.vue";

export default {
  components: {
    Navigation,
    Cart
  },
  data() {
    return {
      isLoaded: false
    };
  },
  beforeCreate() {
    this.$store.dispatch("loadContent").then(() => {
      this.isLoaded = true;
    });
  },
  computed: {
    site() {
      return this.$store.state.site;
    }
  },
  metaInfo() {
    return {
      title: "Estelle Bourdet",
      titleTemplate: "Estelle Bourdet" + " %s"
    };
  }
};
</script>

<style lang="scss">
@import "node_modules/reset-css/sass/_reset";

@font-face {
  font-family: "Walter";
  src: url("/public/fonts/Walter-Regular.woff"),
    url("/public/fonts/Walter-Regular.woff2");
}

// ::-webkit-scrollbar {
//     width: 0;
//     background: transparent;
// }
* {
  box-sizing: border-box;
}
body,
html {
  // scrollbar-width: none;
  background: #e9e6e6;
  width: 100%;
  height: 100%;
  // height: auto;
}

a,
a:active,
a:hover,
a:visited {
  color: black;
  text-decoration: none;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  outline: 0;
}

input::-moz-focus-inner {
  border: 0;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
  .gallery,
  .projects {
    transition: opacity 0.25s;
  }
}
.fade-leave-active {
  .gallery,
  .projects {
    transform: translateX(10%);
  }
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
  .gallery,
  .projects {
    opacity: 0;
    transform: translateX(10%);
  }
}

#app {
  font-family: "Walter", sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  font-variant-ligatures: none;
  font-feature-settings: "liga" 0, "clig" 0;
  font-size: 0.9rem;
  width: 100%;
  height: 100%;
  @media only screen and (max-width: 768px) {
    font-size: 0.8rem;
  }
  letter-spacing: 0.3em;
  line-height: 1.3;
  text-transform: uppercase;
  p {
    margin-bottom: 1em;
    letter-spacing: 0.15em;
    // text-transform: lowercase;
    &:last-of-type {
      margin-bottom: 0;
    }
  }
  .txt {
      text-transform: none;
      letter-spacing: 0.1em;
      padding-right: 0.5em;
      p {
        margin-bottom: 1em !important;
      }
      a {
        transition: letter-spacing 0.2s;
        &:hover {
          letter-spacing: 0.4em;
        }
      }
    }
  header {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 999;
    box-sizing: border-box;
    width: 100%;
    padding: 1em;
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    grid-gap: 1em;
    transition: opacity 0.5s;
    &.hidden {
      opacity: 0;
      pointer-events: none;
    }
    .title {
      grid-column: span 2;
      z-index:99;
      @media only screen and (max-width: 1300px) {
        grid-column: span 1;
      }
      @media only screen and (max-width: 768px) {
        grid-column: span 2;
      }
      a {
        h1 {
          display: inline-block;
          &:first-of-type {
            margin-right: 1em;
          }
          span {
            position: relative;
            display: inline-block;
            transition: transform 0.2s;
          }
        }
        &:hover {
          h1 {
            &:first-of-type {
              span {
                &:nth-of-type(1) {
                  transform: translate(0, 0.4rem);
                }
                &:nth-of-type(3) {
                  transform: translate(0, 0.6rem);
                }
                &:nth-of-type(5) {
                  transform: translate(0, 0.2rem);
                }
                &:nth-of-type(7) {
                  transform: translate(0, 0.8rem);
                }
                @media only screen and (max-width: 768px) {
                  &:nth-of-type(1) {
                    transform: translate(0, 0);
                  }
                  &:nth-of-type(3) {
                    transform: translate(0, 0);
                  }
                  &:nth-of-type(5) {
                    transform: translate(0, 0);
                  }
                  &:nth-of-type(7) {
                    transform: translate(0, 0);
                  }
                }
              }
            }
            &:last-of-type {
              span {
                &:nth-of-type(2) {
                  transform: translate(0, 0.4rem);
                }
                &:nth-of-type(4) {
                  transform: translate(0, 0.6rem);
                }
                &:nth-of-type(6) {
                  transform: translate(0, 0.2rem);
                }
              }
            }
          }
        }
      }
    }
  }
  main {
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    padding: 5em 1em 1em;
    // padding-bottom:0;
    @media only screen and (max-width: 768px) {
      padding-top: 7em;
    }
  }
  li,
  ul {
    list-style: none;
    margin: 0;
    padding: 0;
  }
}
</style>
